<div class="toolbar-container">
    <div class="cadre-logo">
        <img src="../../assets/img/cadre-management-logo.png" alt="">
    </div>
    <div class="user-profile">
        <div class="userNameRole">
            <button class="user-menu-trigger" type="button" (click)="togglePopOver($event)" aria-label="Open user roles menu">
                <span class="user-avatar">
                    <img [src]="userImg || '../../assets/img/user-icon.png'" alt="">
                    <span class="user-status" aria-hidden="true"></span>
                </span>
                <span class="info">
                    <span class="role-id">{{userDetails?.userName | titlecase}}</span>
                    <span class="mobile-no">{{ getSelectedRoleDisplayName() }}</span>
                </span>
                <i class="fa-solid fa-chevron-down" [class.open]="showPopOver" aria-hidden="true"></i>
            </button>
        </div>
        <div class="pop-over-container" [ngClass]="{'open': showPopOver}">
            <div class="pop-over">
                <mat-accordion class="roles-accordion" multi="false">
                    <mat-expansion-panel class="roles-panel" [expanded]="true">
                        <mat-expansion-panel-header class="roles-header">
                            <mat-panel-title>
                                <span class="roles-title">
                                    <img src="assets/img/user-roles.svg" alt="" aria-hidden="true" />
                                    {{ 'yourRoles' | translate }}
                                </span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <ul class="role-list">
                            <li *ngFor="let role of rolesGroup">
                                <button
                                    type="button"
                                    class="role-option"
                                    (click)="changeRole(role)"
                                    [ngClass]="{
                                        'active-role': role === userDetails?.selectedRoleWithGeo
                                    }">
                                    <span class="role-marker" aria-hidden="true"></span>
                                    <span>{{ getRoleNameWithBracket(role) }}</span>
                                </button>
                            </li>
                        </ul>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="sign-out-button">
                    <button type="button" (click)="signOutUser()">
                        <img src="assets/img/logout.svg" />
                        <span>{{'signOut' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
